/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBodyTypename =
  "PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBody" as const;

/**
 *
 * @export
 * @interface PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBody
 */
export interface PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBody {
  /**
   *
   * @type {number}
   * @memberof PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBody
   */
  minIntegratedCounselingIntervalMinutes: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBody
   */
  readonly __typename?: string;
}

export function PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBodyFromJSON(
  json: any
): PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBody {
  return PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBodyFromJSONTyped(json, false);
}

export function PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBodyTypename,

    minIntegratedCounselingIntervalMinutes: json["min_integrated_counseling_interval_minutes"],
  };
}

export function PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBodyToJSON(
  object?: PutPharmacyMinIntegratedCounselingIntervalMinutesRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    min_integrated_counseling_interval_minutes: value.minIntegratedCounselingIntervalMinutes,
  };
}
